import api from '@/api/app';

const app = {
  state: {
    userInfo: {},
    schoolName: '',
    title: '',
    header: {},
    schoolIps: [],
    visitorSchoolIps: [],
    schoolsArray: [],
    visitorInfo: {}
  },
  mutations: {
    SET_USER_INFO: (state, user) => {
      if (user === null) {
        state.userInfo = {};
        state.schoolName = '';
        state.schoolsArray = [];
        return;
      }
      state.userInfo = {
        ...state.userInfo,
        ...user
      };
      const schoolName = user.defaultSchoolName;
      state.schoolName = schoolName;
      state.schoolsArray = [];
      state.schoolsArray.push({
        text: schoolName,
        value: schoolName
      });
      const schools = user.schools;
      if (schools.length > 0) {
        schools.forEach(element => {
          const school_name = element.school_name;
          if (school_name !== schoolName && school_name !== '爱学班班模拟校园') {
            state.schoolsArray.push({
              text: element.school_name,
              value: element.school_name
            });
          }
        });
      }
    },
    SET_APP_TITLE: (state, title) => {
      state.title = title;
    },
    SET_SCHOOL_IPS: (state, ips) => {
      state.schoolIps = ips;
    },
    SET_VISITOR_SCHOOL_IPS: (state, ips) => {
      state.visitorSchoolIps = ips;
    },
    SET_SCHOOL_NAME: (state, name) => {
      state.schoolName = name;
    },
    SET_APP_HEADER: (state, payload) => {
      state.header = {
        ...state.header,
        ...payload
      };
    },
    SET_VISITOR_INFO: (state, info) => {
      state.visitorInfo = {
        ...state.visitorInfo,
        ...info
      };
    }
  },
  actions: {
    getUserInfo({ commit }, payload) {
      api
        .fetchUserInfo(payload)
        .then(response => {
          if (response.result.success) {
            commit('SET_USER_INFO', response.result);
          }
        })
        .catch(error => {
          console.log('getUserInfo error = ', error);
        });
    }
  }
};

export default app;
